import { useContext, useEffect, useMemo, useState } from "react";
import { AppContext } from "../App";
import {
  CDN_URL,
  formatDate,
  getInlineLoader,
  getPublishedItems,
  stripHtml,
  truncateText,
} from "../Helpers";
import PageHero from "../ones/PageHero";
import Footer from "../ones/Footer";
import CallToAction from "../ones/callToAction";

export default function NewsLanding() {
  const appContext = useContext(AppContext);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let mounted = true;

    async function init() {
      setReady(false);
      await appContext.getAllNews();
      if (mounted) {
        setReady(true);
      }
    }

    init();

    return () => {
      mounted = false;
    };
  }, []);

  const publishedNews = useMemo(() => {
    return getPublishedItems(appContext.allNews);
  }, [appContext.allNews]);

  if (!ready) {
    return <div className="container mSupportLoading">{getInlineLoader()}</div>;
  }

  return (
    <>
      <PageHero
        title="Recent AGS updates, field insights, and company announcements"
        description="Stay current with AGS milestones, operational highlights, and updates from our surveying, mapping, GIS, and drone work."
        badge="News & Updates"
      />

      <section className="ags-section">
        <div className="container">
          {publishedNews.length > 0 ? (
            <div className="row g-5">
              {" "}
              {/* Increased gap for a more premium, spacious look */}
              {publishedNews.map((item, index) => (
                <div
                  className="col-md-6 col-xl-4"
                  key={item.uuid || index}
                  data-aos="fade-up"
                  data-aos-delay={index * 40}
                >
                  <article
                className="ags-modern-news-item"
                role="button"
                tabIndex={0}
                aria-label={`Open news article ${item.title}`}
                onClick={() =>
                  appContext.navTo({
                    item: "news",
                    subItem: item.slug || item.uuid,
                  })
                }
                onKeyDown={(event) => {
                  if (event.key === "Enter" || event.key === " ") {
                    appContext.navTo({
                      item: "news",
                      subItem: item.slug || item.uuid,
                    });
                  }
                }}
              >
                <div className="ags-news-image-frame">
                  <img
                    src={`${CDN_URL}${item.coverPhoto}`}
                    alt={item.title}
                    className="ags-news-pure-img"
                  />
                </div>
                <div className="ags-news-content-block">
                  <div className="ags-news-meta mb-2">
                    <span className="ags-meta-label">Published</span>
                    <span className="ags-meta-divider">/</span>
                    <time className="ags-meta-date">
                      {formatDate(item.dateCreated, true)}
                    </time>
                  </div>
                      <h4 className="ags-news-headline font-bold mb-3">
                        {item.title}
                      </h4>
                      {item.publication ? (
                        <div className="mt-2">
                          <span className="badge bg-info text-dark">Publication</span>
                        </div>
                      ) : null}
                </div>
              </article>
                </div>
              ))}
            </div>
          ) : (
            <div
              className="ags-empty-state-minimal text-center"
              data-aos="fade-up"
            >
              <p className="ags-section-kicker mb-2">News & Updates</p>
              <h3 className="font-bold mb-3">No published updates yet</h3>
              <p className="text-muted mb-0">
                Once a story is published, it will appear here automatically.
              </p>
            </div>
          )}
        </div>
      </section>

      <CallToAction />

      <Footer />
    </>
  );
}
